import { axios } from '@js/utilities/axios.js';
import eventBus from '@js/utilities/event-bus.js';

let fetchTodoCancelToken = null;

export default {
	namespaced: true,
	state: {
		todo: {
			assignees: [],
		},
		todo_copy: {},
		isEditing: false,
		isCreating: false,
	},
	mutations: {
		setTodo(state, payload) {
			state.todo = payload;
		},
		setTodoCopy(state, payload) {
			state.todo_copy = { ...payload };
		},
		setIsEditing(state, payload) {
			state.isEditing = payload;
		},
		setIsCreating(state, payload) {
			state.isCreating = payload;
		},
		setAssignees(state, assignees) {
			state.todo.assignees = assignees;
		},
	},
	actions: {
		fetchTodo(context, id) {
			if (fetchTodoCancelToken) {
				fetchTodoCancelToken.cancel();
			}

			fetchTodoCancelToken = axios.CancelToken.source();

			return axios
				.get(`/api/todos/${id}`, {
					cancelToken: fetchTodoCancelToken.token,
				})
				.then((response) => {
					const data = {
						...response.data.data,
						due_date: response.data.data.due_date
							? moment(response.data.data.due_date).format('YYYY-MM-DD')
							: null,
					};

					context.commit('setTodo', data);
					context.commit('setTodoCopy', data);
				})
				.catch((error) => {
					if (!axios.isCancel(error)) {
						toastr.error('An error occurred while fetching the todo');
					}

					throw error;
				});
		},
		upsert(context) {
			let data = {
				assignees: context.state.todo.assignees ? context.state.todo.assignees.map((u) => u.id) : [],
				title: context.state.todo.title,
				description: context.state.todo.description,
				priority: context.state.todo.priority,
				due_date: context.state.todo.due_date ? moment(context.state.todo.due_date).format('YYYY-MM-DD') : null,
				type: context.state.todo.type,
				flagged: context.state.todo.flagged,
				booking_id: context.state.todo.booking_id,
				cleaner_id: context.state.todo.cleaner_id,
			};

			if (context.state.todo.id) {
				return axios.put(`/api/todos/${context.state.todo.id}`, data);
			} else {
				return axios.post('/api/todos', data);
			}
		},
		setIsEditing(context, payload) {
			context.commit('setIsEditing', payload);
		},
		setIsCreating(context, payload) {
			context.commit('setIsCreating', payload);
		},
		setAssignees(context, assignees) {
			context.commit('setAssignees', assignees);
		},
		resetTodo(context) {
			context.commit('setTodo', {});
			context.commit('setTodoCopy', {});
		},
		markAsComplete(context, todo) {
			return axios
				.put(`/api/todos/${todo.id}/complete`)
				.then(() => {
					toastr.success('Marked todo as completed');
				})
				.catch(() => {
					toastr.error('An error occurred while marking the todo as complete');
				});
		},
		markAsIncomplete(context, id) {
			return axios
				.put(`/api/todos/${id}/uncomplete`)
				.then(() => {
					toastr.success('Marked todo as incomplete');

					context.dispatch('fetchTodo', id);

					eventBus.$emit('todos.updated');
				})
				.catch(() => {
					toastr.error('An error occurred while marking the todo as incomplete');
				});
		},
		delete(context, id) {
			return axios
				.delete(`/api/todos/${id}`)
				.then(() => {
					toastr.success('Todo deleted');
				})
				.catch(() => {
					toastr.error('An error occurred while deleting the todo');
				});
		},
	},
	getters: {
		getTodo(state) {
			return state.todo;
		},
		getTodoCopy(state) {
			return state.todo_copy;
		},
		getIsEditing(state) {
			return state.isEditing;
		},
		getIsCreating(state) {
			return state.isCreating;
		},
		canEdit(state) {
			return !state.todo.completed_at;
		},
	},
};
